import GiftcardPage from './pages/GiftcardPage.vue';

const routes = [
  {
    path: '/giftcards',
    name: 'store-giftcards',
    component: GiftcardPage,
    meta: {
      title: 'Cartes Cadeaux - Kingrecharges Store',
    }
  },
];

export default routes;
